//fpだからできる
var accordion = {
	init: function(){
		this.nav();
	},
	nav: function(){
		$("a.btn_open_accordion").off().on("click", function(){
			let idx = $("a.btn_open_accordion").index(this);
			accordion.open(idx);
		});
	},
	open: function(idx){
		let $accordion = $(".accordion").eq(idx);
		let h = 0;
		if(idx === 0){
			h = $accordion.find(".accordion_content p").outerHeight() + $accordion.find(".accordion_content p.note").outerHeight() + $accordion.find(".accordion_content .link").outerHeight() + 40;
		}else{
			h = $accordion.find(".accordion_content p").outerHeight();
		}
		console.log(idx, h);
		$accordion.parent().addClass("active");
		$accordion.find(".accordion_inner").animate({
			height: h + "px"
		}, 300);
	}
}